module.exports = __webpack_public_path__ + "static/media/price.6f8e0a0b.svg";